module.exports = __webpack_public_path__ + "static/media/win.b678ea5d.mp3";